/* eslint-disable consistent-return */
/**
 *
 * LinkDetailPopup
 *
 */

import React, { useLayoutEffect } from 'react';
import { Modal } from '@material-ui/core';
import useFocusTrap from 'components/SearchBar/hooks/useFocusTrap';
import { windowScrollTo } from 'utils/embedded';

function LinkDetailPopup({ children, onClose }) {
  const ref = useFocusTrap({
    focusableElements: [],
    shouldIgnoreEvent: tooltipRef =>
      !tooltipRef.current.contains(document.activeElement),
  });

  useLayoutEffect(() => {
    const timer = setTimeout(() => {
      if (!ref.current) {
        return;
      }

      const header = document.getElementById('app-header');
      const headerHeight = header ? header.offsetHeight : 0;
      const modalRect = ref.current.getBoundingClientRect();
      const absoluteModalTop = modalRect.top + window.scrollY;
      const scrollY = absoluteModalTop - headerHeight - 100;

      windowScrollTo(0, scrollY);
      ref.current.focus({ preventScroll: true });
    }, 0);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Modal
      open
      disableAutoFocus
      disableEnforceFocus
      disablePortal
      disableScrollLock
      onClose={onClose}
      style={{ position: 'static' }}
      BackdropProps={{ style: { zIndex: 10 } }}
      aria-labelledby="title"
    >
      {React.cloneElement(children, { ref, tabIndex: 0 })}
    </Modal>
  );
}

export default LinkDetailPopup;
